import ar from './ar.json';
import en from './en.json';

/**
 * The Auth module's own catalogue, registered from the `app.config.tsx` bridge
 * under the `auth` namespace — `shared/i18n` never imports a module (W2).
 */
export const authCatalogs = { ar, en };
